import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

export const getAdminProducts = createAsyncThunk(
    'adminShop/getAdminProducts',
    async () => {
        const token = localStorage.getItem('ticino-wild-token');
        const url = `${process.env.REACT_APP_SERVER_BASE_URL}/products/get-admin-products`;
        const headers = { 'Content-Type': 'application/json', authorization: `Bearer ${token}` };
        const options = { method: 'GET', headers };
        const response = await fetch(url, options);
        if (response.ok) {
            const result = await response.json();
            return result;
        } else {
            const error = await response.json();
            throw new Error(error);
        }
    }
)

const adminShopSlice = createSlice({
    name: 'adminShop',
    initialState: {
        isLoading: false,
        error: null,
        data: null,
        isNeedRefresh: false
    },
    reducers: {
        setIsNeedRefresh: (state, action) => {
            state.isNeedRefresh = action.payload
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAdminProducts.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getAdminProducts.fulfilled, (state, action) => {
                state.data = action.payload.payload;
                state.error = null;
                state.isLoading = false;
            })
            .addCase(getAdminProducts.rejected, (state, action) => {
                state.error = action.error;
                state.data = null;
                state.isLoading = false;
            })
    }
})

export const { setIsNeedRefresh } = adminShopSlice.actions;
export default adminShopSlice.reducer;